import { styled, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useIndexTypes } from "stores";
import infoIcon from "../../assets/icons/info.svg";
import SmallText from "../Typography/SmallText";

const BarStyled = styled("div")(({ theme }) => ({
  display: "flex",
  width: "400px",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "0.5rem",
  padding: "0.5rem",
  background: "rgba(35, 61, 77, 0.4)",
  borderRadius: "0.5rem",
  backdropFilter: "blur(2px)",
  "& .info-icon": {
    cursor: "pointer",
  },
  "& .bar-container": {
    flexGrow: 1,
    "& .edge-values": {
      display: "flex",
      justifyContent: "space-between",
      "& p": {
        color: theme.color.white100,
      },
    },
    "& .bar": {
      width: "100%",
      height: "10px",
      borderRadius: "0.25rem",
    },
  },
  "& .cloud-coverage": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.25rem",
    "& p": {
      color: theme.color.white100,
      textShadow: "2px 2px 2px black",
    },
    "& .cloud-bar": {
      width: "100%",
      height: "10px",
      background: "#d9d9d9",
      boxShadow: "inset 0px 2px 3px rgba(0, 0, 0, 0.25)",
      borderRadius: "0.25rem",
    },
  },
}));

const IndexesBar = ({ indexType }) => {
  const { t } = useTranslation();

  const {
    getGradientOfIndexType,
    getRangeOfIndexType,
    getDescriptionOfIndexType,
  } = useIndexTypes();

  const indexGradient = getGradientOfIndexType(indexType);
  const range = getRangeOfIndexType(indexType);
  const description = getDescriptionOfIndexType(indexType);

  return (
    <BarStyled>
      <Tooltip title={description} placement="bottom">
        <img src={infoIcon} alt="info" className="info-icon" />
      </Tooltip>
      <div className="bar-container">
        <div className="edge-values">
          <SmallText>{range.min}</SmallText>
          <SmallText>{range.max}</SmallText>
        </div>
        <div
          className="bar"
          style={{
            background: indexGradient,
          }}
        />
      </div>
      <div className="cloud-coverage">
        <SmallText>
          {t("Agro.Indices.CloudCoveragePrct", { cloud: undefined })}
        </SmallText>
        <div className="cloud-bar" />
      </div>
    </BarStyled>
  );
};

export default IndexesBar;
